import {isEmpty, isNil} from 'lodash'
import * as Types from './types'

export const getIpPools = (payload: Types.Ip[]): Types.IpPoolHash =>  {
  return payload.reduce( (pools: Types.IpPoolHash, next: Types.Ip) => {
    const nextIpPools = isEmpty(next.pools) ? ['default'] : next.pools
    nextIpPools.forEach((pool: string) => {
      if (isNil(pools[pool])) {
        pools[pool] = [next]
      } else {
        pools[pool].push(next)
      }
    })
    return pools
  }, {})
}

export const getCommunityPools = (payload: Types.Community[]): Types.CommunityPoolHash => {
  return payload.reduce( (pools: Types.CommunityPoolHash, next: Types.Community) => {
    if (isNil(pools[next.ip_pool])) {
      pools[next.ip_pool] = [next]
    } else {
      pools[next.ip_pool].push(next)
    }
    return pools
  }, {})
}

export const sortCommunityLabels = (a: Types.Community, b: Types.Community) => {
  if (a.community_identifier.toUpperCase() > b.community_identifier.toUpperCase()) {
    return 1
  } else if (a.community_identifier.toUpperCase() < b.community_identifier.toUpperCase()) {
    return -1
  }
}



// WEBPACK FOOTER //
// ./src/pages/ip-pools/utils.ts